interface RemoveTripButtonProps {
  onClick: () => void;
}

const RemoveTripButton = ({ onClick }: RemoveTripButtonProps) => {
  return (
    <div className="flex items-end rounded pb-2.5">
      <button
        type="button"
        className="rounded-full focus:outline-gray-500 focus:ring-gray-500 focus:border-gray-500 focus:ring-offset-nok-800 focus:outline-offset-2 text-black hover:bg-nok-700"
        onClick={onClick}
      >
        <svg
          fill="currentColor"
          height="24"
          viewBox="0 0 256 256"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M168.49,104.49,145,128l23.52,23.51a12,12,0,0,1-17,17L128,145l-23.51,23.52a12,12,0,0,1-17-17L111,128,87.51,104.49a12,12,0,0,1,17-17L128,111l23.51-23.52a12,12,0,0,1,17,17ZM236,128A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Z"></path>
        </svg>
      </button>
    </div>
  );
};

export default RemoveTripButton;
